"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CheckroomSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.5,4 C9.27614237,4 10,4.72385763 10,5.5 C10,6.10609473 9.75231367,6.49826475 9.3,6.8375 L9.05925926,7.01111111 C9.0192791,7.04109623 9.0059418,7.04950635 9.00166878,7.04039254 L9,7.749 L14.776,12.082 L14.8959355,12.2455521 C14.9724252,12.3584821 14.9919735,12.4249038 14.9673304,12.5340671 L14.9473435,12.6054081 L14.878,12.796 L14.7632423,12.9025195 C14.7326779,12.9276299 14.7066297,12.94393 14.6755817,12.956178 L14.6240703,12.9721055 L14.47,13 L2.53,13 L2.35028207,12.9459839 C2.15482535,12.8808846 2.11968881,12.8271256 2.04868913,12.5885235 L2.02,12.49 L2.04789445,12.3359297 C2.05727976,12.2975029 2.06833822,12.2688338 2.08582786,12.2404066 L2.11748046,12.1967577 L2.224,12.082 L7.999,7.749 L8,7 C8,6.69762153 8.12616102,6.48950684 8.35497821,6.29424513 L8.50953842,6.17448681 L8.7,6.0375 C8.92268633,5.87048525 9,5.74807194 9,5.5 C9,5.27614237 8.72385763,5 8.5,5 C8.22141496,5 8.04303049,5.12815731 8.00682881,5.39388509 L8,5.5 L7,5.5 C7,4.57634541 7.6630206,4 8.5,4 Z M8.5,8.625 L3.999,12 L12.999,12 L8.5,8.625 Z" })));
};
CheckroomSmall.displayName = 'CheckroomSmall';
exports.default = CheckroomSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CheckroomSmall.js.map